import * as apiRedux from './api/redux'
import * as appRedux from './app/redux'
import * as authRedux from './auth/redux'
import * as declarationRedux from './declaration/redux'
import * as pageRedux from './page/redux'
import * as trackingRedux from './tracking/redux'
import * as configurationRedux from './configuration/redux'
import * as institutionsRedux from './institutions/redux'

export const actions = {
  app: appRedux.actions,
  api: apiRedux.actions,
  auth: authRedux.actions,
  declaration: declarationRedux.actions,
  page: pageRedux.actions,
  tracking: trackingRedux.actions,
  configuration: configurationRedux.actions,
  institutions: institutionsRedux.actions,
}

export const selectors = {
  app: appRedux.selectors,
  api: apiRedux.selectors,
  auth: authRedux.selectors,
  declaration: declarationRedux.selectors,
  page: pageRedux.selectors,
  tracking: trackingRedux.selectors,
  configuration: configurationRedux.selectors,
  institutions: institutionsRedux.selectors,
}

export const reducers = {
  app: appRedux.reducer,
  api: apiRedux.reducer,
  auth: authRedux.reducer,
  declaration: declarationRedux.reducer,
  page: pageRedux.reducer,
  tracking: trackingRedux.reducer,
  configuration: configurationRedux.reducer,
  institutions: institutionsRedux.reducer,
}
